/** Inline validation message under an input — announced by screen readers. */
export function FieldError({ message, id }: { message: string | null | undefined; id?: string }) {
  if (!message) return null;
  return (
    <p role="alert" {...(id ? { id } : {})} className="text-error text-xs">
      {message}
    </p>
  );
}

/** Form-level error banner (rules that are not about one input). */
export function FormError({ message }: { message: string | null | undefined }) {
  if (!message) return null;
  return (
    <p role="alert" className="bg-error-50 text-error rounded-md px-3 py-2 text-sm">
      {message}
    </p>
  );
}
